import axios from 'axios';
import { API_ENDPOINTS } from '../config/api';
import { authUtils } from '../utils/auth';

export interface LoadedJobData {
  job_title?: string;
  company_name?: string;
  job_url?: string;
  url?: string;
  [key: string]: any;
}

export const jobLoadService = {
  async loadJob(cipher: string): Promise<{ success: boolean; data?: LoadedJobData; error?: string }> {
    try {
      const response = await axios.get(
        `${API_ENDPOINTS.AI_JOB_SEARCH.LOAD_JOB}?cipher=${encodeURIComponent(cipher)}`,
        { headers: { Authorization: `Bearer ${authUtils.getToken()}` }, timeout: 20000 }
      );
      if (response.data.success) return { success: true, data: response.data.data };
      return { success: false, error: response.data.message || 'Failed to load job' };
    } catch (err: any) {
      if (err.response?.status === 400)
        return { success: false, error: 'This job link is invalid or has expired.' };
      return { success: false, error: 'Could not load job details. Please try again.' };
    }
  },

  async createJobCard(jobData: LoadedJobData): Promise<{ success: boolean; jobUrl: string; error?: string }> {
    try {
      const jobUrl = jobData.job_url || jobData.url || '';
      await axios.post(
        `${API_ENDPOINTS.JOB_TRACKER.BASE_URL}/api/jobs`,
        {
          job_title: jobData.job_title || 'Unknown Position',
          job_url: jobUrl,
          company_name: jobData.company_name || 'Unknown Company',
          status: 'Viewed',
        },
        { headers: { Authorization: `Bearer ${authUtils.getToken()}` } }
      );
      return { success: true, jobUrl };
    } catch (err: any) {
      return { success: false, jobUrl: '', error: 'Failed to save job to tracker.' };
    }
  },
};
